import React, { useState, useContext } from 'react'
import RayIcon from '../../icons/Ray'
import { EditDialog } from '../../dialogs/editDialog'
import { createPortal } from 'react-dom'
import { ProjectContext } from '../../../context/ProjectContext'
// import { customFetch } from '../../../utils'
// import toast from 'react-hot-toast'
// import { useDebounce } from '../../../hooks/useDebounce'

const Problems = ({ project, problems, setProblems, meetings, setProject, participants, useTwoColumns = false }) => {
  const [showEditDialog, setShowEditDialog] = useState(false)
  const [noteHover, setNoteHover] = useState(null)
  const [noteContent, setNoteContent] = useState('')
  const [showPercentage, setShowPercentage] = useState(false)
  const { meetings: allMeetings } = useContext(ProjectContext)

  // const debouncedNoteContent = useDebounce(noteContent, 1000)
  //
  // useEffect(() => {
  //   if (!noteContent) return
  //   const handleChangeNoteContent = async (content) => {
  //     try {
  //       setProblems((prevNotes) => prevNotes.map((n) => (n.id === noteHover?.id ? { ...n, content } : n)))
  //       await customFetch('/updateProblemContent', 'PUT', { problemId: noteHover?.id, content })
  //     } catch (error) {
  //       console.log(error)
  //       toast.error('Whoops! Something went wrong. Please try again.')
  //     }
  //   }
  //   handleChangeNoteContent(noteContent)
  // }, [debouncedNoteContent])

  const handleShowPercentage = (id, show) => {
    setShowPercentage(show ? id : null)
  }

  return (
    <div className="container mx-auto px-4 pt-5">
      <div className={`grid grid-cols-1 md:grid-cols-2 ${useTwoColumns ? '' : 'lg:grid-cols-3 xl:grid-cols-4'} gap-4`}>
        {problems.map((item) => (
          <div
            className="max-w-sm p-6 bg-white rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 text-center relative"
            onDoubleClick={() => setShowEditDialog(true)}
            key={item.id}
            onMouseEnter={() => setNoteHover(item)}
          >
            {/* Cluster badge */}
            {Array.isArray(item.clustered_notes) && item.clustered_notes.length > 0 && item.meetings_count > 1 && (
              <div
                className="absolute -top-2 -right-2 z-10"
                onMouseEnter={() => handleShowPercentage(item.id, true)}
                onMouseLeave={() => handleShowPercentage(item.id, false)}
              >
                <div
                  className={`relative transition-all duration-200 ease-in-out ${showPercentage === item.id ? 'w-[48px]' : 'w-[32px]'} h-[32px]`}
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    className={`absolute transition-opacity duration-200 ${showPercentage === item.id ? 'opacity-0' : 'opacity-100'}`}
                  >
                    <circle cx="16" cy="16" r="13" fill="black" stroke="#333333" strokeWidth="3" />
                    <circle
                      cx="16"
                      cy="16"
                      r="13"
                      fill="none"
                      stroke="#FF4A8E"
                      strokeWidth="4"
                      strokeLinecap="round"
                      strokeDasharray={`${(Math.round((item.meetings_count * 100) / allMeetings.length) / 100) * 81.68} 81.68`}
                      transform="rotate(-90 16 16)"
                    />
                  </svg>
                  <div
                    className={`absolute inset-0 flex items-center justify-center ${showPercentage === item.id ? 'bg-black rounded-full px-2' : ''}`}
                  >
                    <span className="text-white text-sm font-bold font-['Manrope'] leading-none transition-all duration-200 whitespace-nowrap">
                      {showPercentage === item.id
                        ? `${Math.round((item.meetings_count * 100) / allMeetings.length)}%`
                        : item.meetings_count}
                    </span>
                  </div>
                </div>
              </div>
            )}

            <div className="flex justify-center">
              <RayIcon />
            </div>
            <h3 className="font-semibold text-lg mb-2 text-red-600 mt-2 capitalize">{item.title || item.referent}</h3>
            <p className="text-gray-700">{item.content}</p>
          </div>
        ))}
      </div>
      {showEditDialog &&
        createPortal(
          <EditDialog
            entity={noteHover}
            entityName={'problem'}
            project={project}
            participants={participants}
            rating={false}
            tagging={false}
            readOnly={true}
            setProject={setProject}
            setEntities={setProblems}
            meeting={meetings.find((meet) => meet.id === noteHover.meetingId) || {}}
            close={() => setShowEditDialog(false)}
            changeContent={(content) => setNoteContent(content)}
          />,
          document.body
        )}
    </div>
  )
}

export default Problems
